import { render, staticRenderFns } from "./ResourceTable.vue?vue&type=template&id=ffd56316"
import script from "./ResourceTable.vue?vue&type=script&lang=js"
export * from "./ResourceTable.vue?vue&type=script&lang=js"
import style0 from "./ResourceTable.vue?vue&type=style&index=0&id=ffd56316&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports